import React from 'react';

const HOUR_WORDS = [
  'twelve', 'one', 'two', 'three', 'four', 'five',
  'six', 'seven', 'eight', 'nine', 'ten', 'eleven',
];

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

// Convert time to an English phrase, rounded to 5-minute increments.
function timeToWords(time) {
  let hours = time.getHours();
  const minutes = time.getMinutes();
  const rounded = Math.round(minutes / 5) * 5;

  // Use "to" for >30m: ref the next hour
  const refHour = rounded > 30 ? (hours + 1) % 24 : hours;
  const hourWord = HOUR_WORDS[refHour % 12];

  if (rounded === 0 || rounded === 60) {
    if (refHour % 12 === 0 && refHour === 0) return { line1: 'midnight', line2: '' };
    if (refHour % 12 === 0 && refHour === 12) return { line1: 'noon', line2: '' };
    return { line1: hourWord, line2: "o'clock" };
  }
  if (rounded === 15) return { line1: 'quarter past', line2: hourWord };
  if (rounded === 30) return { line1: 'half past', line2: hourWord };
  if (rounded === 45) return { line1: 'quarter to', line2: hourWord };

  const mins = rounded > 30 ? 60 - rounded : rounded;
  const minWord = {
    5: 'five', 10: 'ten', 20: 'twenty', 25: 'twenty-five',
    35: 'twenty-five', 40: 'twenty', 50: 'ten', 55: 'five',
  }[rounded] || 'five';

  const prep = rounded > 30 ? 'to' : 'past';
  return { line1: `${minWord} ${prep}`, line2: hourWord };
}

export default function WordClock({ time, settings, dark, palette }) {
  const accent = palette?.[0] || '#3b82f6';
  const { line1, line2 } = timeToWords(time);
  const isPM = time.getHours() >= 12;

  return (
    <div className="flex flex-col items-center text-center">
      <div
        className={`text-5xl md:text-7xl font-dm-serif italic leading-tight ${dark ? 'text-white/85' : 'text-gray-800/90'}`}
      >
        {line1}
      </div>
      {line2 && (
        <div
          className="text-6xl md:text-8xl font-dm-serif font-bold leading-tight mt-1"
          style={{ color: accent }}
        >
          {line2}
        </div>
      )}
      <div className={`text-sm font-rasa tracking-[0.3em] mt-4 ${dark ? 'text-white/40' : 'text-gray-500/70'}`}>
        {isPM ? 'PM' : 'AM'}
        {settings.showSeconds && ` · ${String(time.getSeconds()).padStart(2, '0')}s`}
      </div>
      {settings.showDate && (
        <div className={`text-base font-rasa mt-3 ${dark ? 'text-white/50' : 'text-gray-500/70'}`}>
          {DAYS[time.getDay()]}, {MONTHS[time.getMonth()]} {time.getDate()}
        </div>
      )}
    </div>
  );
}
